import TopTips from '@/components/TopTips';
import { openInBrowser } from '@/utils/bridge';
import { useCallback } from 'react';

const ExtraTips = ({
  url,
  text = '仅支持单线上网或管理信息查看，若设备多线拨号/多静态ip，请前往控制台查看线路状态，',
  className,
}) => {
  const handleJumpClick = useCallback(
    e => {
      e.preventDefault();
      if (url) openInBrowser({ url });
    },
    [url]
  );

  return (
    <TopTips className={className}>
      <p onClick={handleJumpClick}>
        {text}
        <span>控制台操作指引&gt;&gt;</span>
      </p>
    </TopTips>
  );
};
export default ExtraTips;
